export function getAddToTrackEventPayload({ item, eventId }) {
  return {
    content_name: `${item.title} - ${item.offer.name}`,
    content_ids: [`${item.offer.sku}`],
    content_type: 'product',
    // For example'Apparel & Accessories > Shoes',
    content_category: createFBContentCategory({ magazine: item }),
    value: Number(item.offer.cpa).toFixed(2),
    currency: 'GBP',
    eventID: eventId
  }
}

export function sendSSAPIPageView({ context, parameters }) {
  // Facebook Server-side API
  const fbp = context.$cookies.get('_fbp', { parseJSON: false }) || ''
  let fbc = context.$cookies.get('_fbc', { parseJSON: false }) || ''

  let fbclid = context.$route.query.fbclid
  // console.log('fbp=', fbp)
  // console.log('fbc=', fbc)
  // console.log('fbclid=', fbclid)
  // Save the fbclid to the session storage
  fbclid && context.$store.commit('fb/setFbclid', fbclid)

  if (fbclid && fbc === '') {
    // console.log('FOUND COOKIES or QS fbclid=', fbclid)
    const currentTimestamp = Math.floor(new Date() / 1000)
    fbc = `fb.1.${currentTimestamp}.${fbclid}`
  } else if (!fbclid && fbc === '') {
    // get the session storage saved value for fbclid
    fbclid = context.$store.getters['fb/getFbclid']
    if (fbclid) {
      // console.log('FOUND SESSION fbclid=', fbclid)
      const currentTimestamp = Math.floor(new Date() / 1000)
      fbc = `fb.1.${currentTimestamp}.${fbclid}`
    }
  }

  const palyoad = {
    fbp,
    fbc,

    ...parameters
  }
  // console.log('/fb/PageView payload=', palyoad)
  context.$axios
    .$put('/fb/PageView', palyoad)
    .then(response => {
      // console.log('/fb/PageView Response=', response)
    })
    .catch(error => {
      console.log('/fb/PageView Response Error=', error)
    })
}

export function sendSSAPIAddToCart({ item, context, parameters }) {
  // Facebook Server-side API
  const fbp = context.$cookies.get('_fbp', { parseJSON: false }) || ''
  let fbc = context.$cookies.get('_fbc', { parseJSON: false }) || ''

  let fbclid = context.$route.query.fbclid
  // Save the fbclid to the session storage
  fbclid && context.$store.commit('fb/setFbclid', fbclid)

  if (fbclid && fbc === '') {
    // console.log('FOUND COOKIES or QS fbclid=', fbclid)
    const currentTimestamp = Math.floor(new Date() / 1000)
    fbc = `fb.1.${currentTimestamp}.${fbclid}`
  } else if (!fbclid && fbc === '') {
    // get the session storage saved value for fbclid
    fbclid = context.$store.getters['fb/getFbclid']
    if (fbclid) {
      // console.log('FOUND SESSION fbclid=', fbclid)
      const currentTimestamp = Math.floor(new Date() / 1000)
      fbc = `fb.1.${currentTimestamp}.${fbclid}`
    }
  }

  // console.log('sendSSAPIAddToCart item=', item)
  // console.log('sendSSAPIAddToCart parameters=', parameters)
  const palyoad = {
    fbp,
    fbc,
    name: `${item.title} - ${item.offer.name}`,
    sku: item.offer.sku,
    price: Number(item.offer.cpa).toFixed(2),
    content_category: createFBContentCategory({ breadcrumbs: parameters.breadcrumbs, magazine: item }),
    ...parameters
  }
  // console.log('/fb/AddToCart payload=', palyoad)
  context.$axios
    .$put('/fb/AddToCart', palyoad)
    .then(response => {
      // console.log('/fb/AddToCart Response=', response)
    })
    .catch(error => {
      console.log('/fb/AddToCart Response Error=', error)
    })
}

export function sendSSAPIViewContent({ content, context, parameters }) {
  // Facebook Server-side API
  const fbp = context.$cookies.get('_fbp', { parseJSON: false }) || ''
  let fbc = context.$cookies.get('_fbc', { parseJSON: false }) || ''

  let fbclid = context.$route.query.fbclid
  // Save the fbclid to the session storage
  fbclid && context.$store.commit('fb/setFbclid', fbclid)

  if (fbclid && fbc === '') {
    // console.log('FOUND COOKIES or QS fbclid=', fbclid)
    const currentTimestamp = Math.floor(new Date() / 1000)
    fbc = `fb.1.${currentTimestamp}.${fbclid}`
  } else if (!fbclid && fbc === '') {
    // get the session storage saved value for fbclid
    fbclid = context.$store.getters['fb/getFbclid']
    if (fbclid) {
      // console.log('FOUND SESSION fbclid=', fbclid)
      const currentTimestamp = Math.floor(new Date() / 1000)
      fbc = `fb.1.${currentTimestamp}.${fbclid}`
    }
  }

  // console.log('sendSSAPIViewContent content=', content)
  const palyoad = {
    fbp,
    fbc,
    ...content,
    ...parameters
  }
  // console.log('/fb/ViewContent payload=', palyoad)
  context.$axios
    .$put('/fb/ViewContent', palyoad)
    .then(response => {
      // console.log('/fb/ViewContent Response=', response)
    })
    .catch(error => {
      console.log('/fb/ViewContent Response Error=', error)
    })
}

export function sendSSAPIViewAll({ content, context, parameters }) {
  // Facebook Server-side API
  const fbp = context.$cookies.get('_fbp', { parseJSON: false }) || ''
  let fbc = context.$cookies.get('_fbc', { parseJSON: false }) || ''

  let fbclid = context.$route.query.fbclid
  // Save the fbclid to the session storage
  fbclid && context.$store.commit('fb/setFbclid', fbclid)

  if (fbclid && fbc === '') {
    // console.log('FOUND COOKIES or QS fbclid=', fbclid)
    const currentTimestamp = Math.floor(new Date() / 1000)
    fbc = `fb.1.${currentTimestamp}.${fbclid}`
  } else if (!fbclid && fbc === '') {
    // get the session storage saved value for fbclid
    fbclid = context.$store.getters['fb/getFbclid']
    if (fbclid) {
      // console.log('FOUND SESSION fbclid=', fbclid)
      const currentTimestamp = Math.floor(new Date() / 1000)
      fbc = `fb.1.${currentTimestamp}.${fbclid}`
    }
  }

  // console.log('sendSSAPIViewAll parameters=', parameters)
  const palyoad = {
    fbp,
    fbc,
    ...content,
    ...parameters
  }
  // console.log('/fb/ViewAll payload=', palyoad)
  context.$axios
    .$put('/fb/ViewAll', palyoad)
    .then(response => {
      // console.log('/fb/ViewAll Response=', response)
    })
    .catch(error => {
      console.log('/fb/ViewAll Response Error=', error)
    })
}

export function createFBContentCategory({ magazine }) {
  console.log('createFBContentCategory magazine=', magazine)

  if (!magazine.subCategory && !magazine.subCategory) {
    return `SAMPLE Category > SAMPLE Sub Category`
  }

  if (magazine.subCategory === 'BLANK') {
    return `${magazine.category}`
  }

  return `${magazine.category} > ${magazine.subCategory}`
}

export function createUniqueFBEventId(event) {
  const currentTimestamp = Math.floor(new Date() / 1000)
  const randomToken = Math.floor(Math.random() * 10000)
  return `${event}-${currentTimestamp}-${randomToken}`
}
